unit Search.XFuelsDepots;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client;

type
  TfrmSearchXFuels = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    weSearch: TEdit;
    dgSearch: TTMSFNCDataGrid;
    dgdbaSearch: TTMSFNCDataGridDatabaseAdapter;
    wcSearch: TXDataWebClient;
    wdsSearch: TXDataWebDataSet;
    dsSearch: TDataSource;
    wdsSearchdepotcode: TIntegerField;
    wdsSearchdepotname: TStringField;
    procedure dgSearchCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure weSearchChange(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    iXFuelsDepotcode : Integer;
    sXFuelsDepotName : String;
  protected procedure LoadDFMValues; override; end;

var
  frmSearchXFuels: TfrmSearchXFuels;

implementation

{$R *.dfm}
uses
  stfmssystem.connection;

procedure TfrmSearchXFuels.dgSearchCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaSearch.SetActiveRecord(ARow);
  iXFuelsDepotcode := dgdbaSearch.FieldAtColumn[0].AsInteger;
  sXFuelsDepotName := dgdbaSearch.FieldAtColumn[1].AsString;
end;

procedure TfrmSearchXFuels.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmSearchXFuels.WebButton2Click(Sender: TObject);
begin
  iXFuelsDepotcode := -1;
  sXFuelsDepotName := '';
end;

procedure TfrmSearchXFuels.WebFormShow(Sender: TObject);

    procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSearch.Close;
      wdsSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSearch.Open;
    end;

begin
  wcSearch.RawInvoke('IstfmsdieselService.Get_XFuelDepots_View',[],@OnSuccess,@OnError);
end;

procedure TfrmSearchXFuels.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case dgSearch.Selection.StartCell.Column of
        0 : wdsSearch.Locate('depotcode', weSearch.Text, [loPartialKey]);
        1 : wdsSearch.Locate('depotname', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

procedure TfrmSearchXFuels.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  weSearch := TEdit.Create(Self);
  dgSearch := TTMSFNCDataGrid.Create(Self);
  dgdbaSearch := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcSearch := TXDataWebClient.Create(Self);
  wdsSearch := TXDataWebDataSet.Create(Self);
  wdsSearchdepotcode := TIntegerField.Create(Self);
  wdsSearchdepotname := TStringField.Create(Self);
  dsSearch := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  weSearch.BeforeLoadDFMValues;
  dgSearch.BeforeLoadDFMValues;
  dgdbaSearch.BeforeLoadDFMValues;
  wcSearch.BeforeLoadDFMValues;
  wdsSearch.BeforeLoadDFMValues;
  wdsSearchdepotcode.BeforeLoadDFMValues;
  wdsSearchdepotname.BeforeLoadDFMValues;
  dsSearch.BeforeLoadDFMValues;
  try
    Name := 'frmSearchXFuels';
    Width := 399;
    Height := 359;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 399;
    WebPanel1.Height := 359;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 399;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Search XFuels Depots';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 259;
    WebPanel3.Width := 399;
    WebPanel3.Height := 100;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 24;
    WebButton1.Top := 56;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Select';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 272;
    WebButton2.Top := 56;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    weSearch.SetParentComponent(WebPanel3);
    weSearch.Name := 'weSearch';
    weSearch.Left := 36;
    weSearch.Top := 22;
    weSearch.Width := 326;
    weSearch.Height := 22;
    weSearch.CharCase := wecUpperCase;
    weSearch.ChildOrder := 2;
    weSearch.Font.Charset := DEFAULT_CHARSET;
    weSearch.Font.Color := clWindowText;
    weSearch.Font.Height := -13;
    weSearch.Font.Name := 'Tahoma';
    weSearch.Font.Style := [];
    weSearch.HeightStyle := ssAuto;
    weSearch.HeightPercent := 100.000000000000000000;
    weSearch.ParentFont := False;
    weSearch.WidthPercent := 100.000000000000000000;
    SetEvent(weSearch, Self, 'OnChange', 'weSearchChange');
    dgSearch.SetParentComponent(WebPanel1);
    dgSearch.Name := 'dgSearch';
    dgSearch.Left := 0;
    dgSearch.Top := 60;
    dgSearch.Width := 399;
    dgSearch.Height := 199;
    dgSearch.Align := alClient;
    dgSearch.ParentDoubleBuffered := False;
    dgSearch.DoubleBuffered := True;
    dgSearch.TabOrder := 2;
    dgSearch.ShowAcceleratorChar := False;
    dgSearch.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgSearch.Header.VisualGrouping.Layout.Font.Height := -12;
    dgSearch.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgSearch.Header.VisualGrouping.Layout.Font.Style := [];
    dgSearch.Adapter := dgdbaSearch;
    dgSearch.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgSearch.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgSearch.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.BandLayout.Font.Height := -12;
    dgSearch.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.BandLayout.Font.Style := [];
    dgSearch.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FixedLayout.Font.Height := -12;
    dgSearch.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FixedLayout.Font.Style := [];
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgSearch.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FocusedLayout.Font.Height := -12;
    dgSearch.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FocusedLayout.Font.Style := [];
    dgSearch.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.GroupLayout.Font.Height := -12;
    dgSearch.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.GroupLayout.Font.Style := [];
    dgSearch.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.NormalLayout.Font.Height := -12;
    dgSearch.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.NormalLayout.Font.Style := [];
    dgSearch.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.SelectedLayout.Font.Height := -12;
    dgSearch.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.SelectedLayout.Font.Style := [];
    dgSearch.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.SummaryLayout.Font.Height := -12;
    dgSearch.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.SummaryLayout.Font.Style := [];
    dgSearch.ColumnCount := 0;
    dgSearch.Designer := False;
    dgSearch.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgSearch.FilterAppearance.Font.Color := clWindowText;
    dgSearch.FilterAppearance.Font.Height := -12;
    dgSearch.FilterAppearance.Font.Name := 'Segoe UI';
    dgSearch.FilterAppearance.Font.Style := [];
    dgSearch.Icons.ExpandIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.ExpandIcon.svg');
    dgSearch.Icons.CollapseIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.CollapseIcon.svg');
    dgSearch.Icons.FilterIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.FilterIcon.svg');
    dgSearch.Icons.FilterActiveIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.FilterActiveIcon.svg');
    dgSearch.Icons.FilterClearIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.FilterClearIcon.svg');
    dgSearch.Icons.FilterTypeIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.FilterTypeIcon.svg');
    dgSearch.Icons.SortAscendingIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.SortAscendingIcon.svg');
    dgSearch.Icons.SortDescendingIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.SortDescendingIcon.svg');
    dgSearch.Icons.CloseIcon.LoadFromFile('Search.XFuelsDepots.WebPanel1.dgSearch.Icons.CloseIcon.svg');
    SetEvent(dgSearch, Self, 'OnCellClick', 'dgSearchCellClick');
    dgSearch.RowCount := 1;
    dgdbaSearch.SetParentComponent(dgSearch);
    dgdbaSearch.Name := 'dgdbaSearch';
    dgdbaSearch.Left := 248;
    dgdbaSearch.Top := 88;
    dgdbaSearch.Width := 26;
    dgdbaSearch.Height := 26;
    dgdbaSearch.Visible := True;
    dgdbaSearch.DataSource := dsSearch;
    wcSearch.SetParentComponent(Self);
    wcSearch.Name := 'wcSearch';
    wcSearch.Connection := dmData.dbConnect;
    wcSearch.Left := 40;
    wcSearch.Top := 140;
    wdsSearch.SetParentComponent(Self);
    wdsSearch.Name := 'wdsSearch';
    wdsSearch.Connection := dmData.dbConnect;
    wdsSearch.Left := 112;
    wdsSearch.Top := 140;
    wdsSearchdepotcode.SetParentComponent(wdsSearch);
    wdsSearchdepotcode.Name := 'wdsSearchdepotcode';
    wdsSearchdepotcode.FieldName := 'depotcode';
    wdsSearchdepotname.SetParentComponent(wdsSearch);
    wdsSearchdepotname.Name := 'wdsSearchdepotname';
    wdsSearchdepotname.FieldName := 'depotname';
    dsSearch.SetParentComponent(Self);
    dsSearch.Name := 'dsSearch';
    dsSearch.DataSet := wdsSearch;
    dsSearch.Left := 184;
    dsSearch.Top := 140;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    weSearch.AfterLoadDFMValues;
    dgSearch.AfterLoadDFMValues;
    dgdbaSearch.AfterLoadDFMValues;
    wcSearch.AfterLoadDFMValues;
    wdsSearch.AfterLoadDFMValues;
    wdsSearchdepotcode.AfterLoadDFMValues;
    wdsSearchdepotname.AfterLoadDFMValues;
    dsSearch.AfterLoadDFMValues;
  end;
end;

end.